/**
 * Colours and dimensions for the Strategy › Treatments › Ignitions scenario
 * bar and its popovers (issue #447). Layout px: the UI may be CSS-zoomed on
 * small screens (index.css --ui-zoom) and MUI handles that for us.
 */
export const SB = {
  chrome: "#212b37",
  well: "#18212b",
  popover: "#1b2531",
  menu: "#232f3d",
  accent: "#00d4ac",
  accentSoft: "#5fe3c6",
  accentMeta: "#8fe9d4",
  text: "#eef3f6",
  textRow: "#e3eaef",
  textBody: "#d9e2e8",
  textTable: "#b4c1cb",
  textIcon: "#a3b2be",
  meta: "#8f9daa",
  label: "#82919e",
  radioOff: "#4f5d6b",
  danger: "#fca5a5",
  ring: "rgba(255,255,255,0.08)",
  hairline: "rgba(255,255,255,0.06)",
  tile: "rgba(255,255,255,0.06)",
  popoverWidth: 380,
  radius: 12,
  rowHeight: 44,
  rowHeightTwoLine: 48,
  undoMs: 6000,
} as const;

/** Neutral greys for the per-type share bar and summary table. Type is told
 *  by icon + label + grey, never by hue: colour on the map means burn year. */
export const TYPE_GREYS = [
  "#cbd5e1",
  "#94a3b8",
  "#64748b",
  "#475569",
  "#a3b2be",
  "#334155",
] as const;

export const typeGrey = (index: number) => TYPE_GREYS[index % TYPE_GREYS.length];

export const labelSx = {
  fontSize: 10,
  lineHeight: "12px",
  fontWeight: 600,
  letterSpacing: "0.09em",
  textTransform: "uppercase" as const,
  color: SB.label,
};

export const tabularSx = { fontVariantNumeric: "tabular-nums" } as const;

export const popInAnimation = {
  "@keyframes sb-pop-in": {
    from: { opacity: 0, transform: "translateY(-4px) scale(0.985)" },
    to: { opacity: 1, transform: "none" },
  },
  animation: "sb-pop-in 160ms cubic-bezier(.2,.8,.2,1)",
  "@media (prefers-reduced-motion: reduce)": { animation: "none" },
} as const;
